import React from "react";
import logo from "./img/logo.svg";
import { Hamburger } from "./Hamburger";
import { Menu } from "./Menu";
import Waypoint from "react-waypoint";
import { NavLink } from "react-router-dom";
export class Header extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isInView: true
    };
  }
  componentDidMount() {
    if (window && window.innerWidth > 559) {
      window.addEventListener("resize", this.onLeave);
      window.addEventListener("resize", this.dummyOnEnter);
    }
  }
  componentWillUnmount() {
    if (window) {
      window.removeEventListener("resize", this.onLeave);
      window.removeEventListener("resize", this.dummyOnEnter);
    }
  }
  onLeave = ({ currentPosition }) => {
    if (window && window.innerWidth > 559) {
      if (currentPosition === Waypoint.above) {
        this.setState({ isInView: false });
      }
    }
  };
  dummyOnEnter = ({ currentPosition }) => {
    if (window && window.innerWidth > 559) {
      if (currentPosition === Waypoint.inside) {
        this.setState({ isInView: true });
      }
    }
  };
  render() {
    return (
      <div>
        {!this.state.isInView && (
          <Waypoint onEnter={this.dummyOnEnter} scrollableAncestor={window}>
            <div
              style={{
                width: "100%",
                maxWidth: "1200px",
                position: "absolute",
                top: "0",
                left: "0",
                height: "112px"
              }}
            />
          </Waypoint>
        )}
        <Waypoint onLeave={this.onLeave} scrollableAncestor={window}>
          <header
            className={
              this.state.isInView ? "page-header" : "page-header sticky"
            }
          >
           
            <NavLink
         className="logo-wrap"
          activeClassName=""
          to={`/`}
        >
          
              <img className="logo" src={logo} alt="logo" />
           
        </NavLink>



            {this.props.isMobile && (
              <Hamburger
                toggleOpenMenu={this.props.toggleOpenMenu}
                isMenuOpen={this.props.isMenuOpen}
              />
            )}
            <nav className={`${this.props.isMenuOpen ? "active" : ""}`}>
              <Menu
                mainMenu={this.props.mainMenu}
                closeMenu={this.props.closeMenu}
                isMenuOpen={this.props.isMenuOpen}
              />
            </nav>
          </header>
        </Waypoint>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Header.js